import { useTranslation } from "react-i18next";
import { TUpcomingClassEvent } from "../../../models/ClassEvent";
import { useState } from "react";
import { useGetUpcomingClassEventsReservationsQuery } from "../../../api/queries";
import { useNavigate } from "react-router";
import {
  useClassEventReservationMutations,
  useOpenGymMutations,
  useSavedPlacedMutations,
} from "../../../api/mutations";

const DEFAULT_UPCOMING_ARRAY = [] as TUpcomingClassEvent[];

export interface ICancelEventParams {
  id: number;
  gymListingId: string;
  type: "GROUP_CLASS" | "OPEN_GYM";
}

export const useUpcoming = () => {
  const navigate = useNavigate();

  const { cancelReservation } = useClassEventReservationMutations();
  const { cancelOpenGymReservation } = useOpenGymMutations();
  // const { deletePlace, savePlace } = useSavedPlacedMutations();

  const { t } = useTranslation();
  const [selectedEventForCancel, setSelectedEventForCancel] = useState<ICancelEventParams | null>(
    null
  );

  const [isLoadingCancel, setIsLoadingCancel] = useState(false);
  const [isCancelledSuccessfully, setIsCancelledSuccessfully] = useState(false);

  const {
    data: upcomingClassEvents = DEFAULT_UPCOMING_ARRAY,
    isLoading,
    refetch,
  } = useGetUpcomingClassEventsReservationsQuery();

  const onCancelReservation = (event: ICancelEventParams) => {
    setSelectedEventForCancel(event);
  };

  const onClickGymImage = (id: string) => {
    if (!id) return;

    navigate(`/gyms-location/${id}`);
  };

  const onConfirmCancelReservation = (id: number, gymListingId: string) => {
    cancelReservation(
      { reservationId: id, gymListingId },
      {
        onSuccess: () => {
          refetch();
          setIsCancelledSuccessfully(true);
        },
        onError: (error) => {
          console.error("Error cancelling reservation:", error);
        },
        onSettled: () => {
          setSelectedEventForCancel(null);
          setIsLoadingCancel(false);
        },
      }
    );
  };

  const onConfirmCancelOpenGymReservation = (id: number, gymListingId: string) => {
    cancelOpenGymReservation(
      { reservationId: id, gymListingId },
      {
        onSuccess: () => {
          refetch();
          setIsCancelledSuccessfully(true);
        },
        onError: (error) => {
          console.error("Error cancelling reservation:", error);
        },
        onSettled: () => {
          setSelectedEventForCancel(null);
          setIsLoadingCancel(false);
        },
      }
    );
  };

  const onConfirmCancelReservationPopup = async () => {
    try {
      if (!selectedEventForCancel) return;

      setIsLoadingCancel(true);

      if (selectedEventForCancel.type === "GROUP_CLASS") {
        await onConfirmCancelReservation(
          selectedEventForCancel.id,
          selectedEventForCancel.gymListingId
        );
      } else {
        await onConfirmCancelOpenGymReservation(
          selectedEventForCancel.id,
          selectedEventForCancel.gymListingId
        );
      }
    } catch (err) {
      console.error("Error cancelling reservation:", err);
    }
  };

  const onCloseConfirmCancelReservationPopup = () => {
    setSelectedEventForCancel(null);
  };

  const onCloseCancelledSuccessfully = () => setIsCancelledSuccessfully(false);

  // const onSaveOrDeletePlace = async (event: TUpcomingClassEvent) => {
  //   if (!event) return;

  //   if (event.) await deletePlace({ id: event.savedPlace.id });
  //   else await savePlace({ gymListingId: event.id });
  //   refetch();
  // };

  return {
    t,
    upcomingClassEvents,
    selectedEventForCancel,
    isLoading,
    isLoadingCancel,
    isCancelledSuccessfully,
    onClickGymImage,
    onCancelReservation,
    onConfirmCancelReservationPopup,
    onCloseConfirmCancelReservationPopup,
    onCloseCancelledSuccessfully,
  };
};
